import { useState } from "react";
import { useMutation } from "@apollo/client";
import toast from "react-hot-toast";
import { UPDATE_USER } from "../mutations/userMutations";
import { useAuthContext } from "../hooks/useAuthContext";
//import { GET_USER_PROFILE } from "../queries/userQueries";

export const useUpdateUserProfile = () => {
  const [error, setError] = useState(null)
  const [isUpdating, setIsUpdating] = useState(false)
  
  const { dispatch } = useAuthContext()
  const [updateUser] = useMutation(UPDATE_USER, {
	onCompleted: ({ updateUser }) => {
	  dispatch({ type: 'UPDATE_USER', payload: updateUser })
	  toast.success("Profile updated successfully");
	},
	onError: (error) => {
	  setError(error.message)
	  toast.error(error.message)
	  throw new Error(error.message)
	}
  })

  const updateProfile = async (id, formData) => {
    setIsUpdating(true)
    setError(null)

	if (!formData) {
	  setError('Please fill in some fields')
	  setIsUpdating(false)

	  return
	}

	try {
	  await updateUser({ variables: { id, ...formData } }) // Pass formData directly
	} catch (error) {
	  setError(error.message)
	} finally {
	  setIsUpdating(false)
	}
  }

  return { updateProfile, isUpdating, error }
}

export default useUpdateUserProfile
